// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__-7-dh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__20XXi"};